import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import Carousel from './Carousel';
import { StyledPreviewModal } from './style';

function PreviewModal({ alphCrid, adSlot, show, onHide, urlList }) {
  return (
    <StyledPreviewModal show={show} onHide={onHide} size="xl">
      <Modal.Header closeButton>
        <Modal.Title>
          Alph Crid : {alphCrid} | AD Slot : {adSlot}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Carousel
          urlList={urlList}
          responsive={{
            all: {
              breakpoint: { max: 4000, min: 0 },
              items: 1,
            },
          }}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </StyledPreviewModal>
  );
}

export default PreviewModal;
